
import React, { useState, useEffect, useCallback } from "react";
import logo from "../assets/vignan_online.png";
import Home from "../Component/students/Home.jsx";
import Wallet from "../Component/students/Wallet.jsx";
import { useAuth } from "../Context/AuthContext.jsx";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useCampaign } from '../Context/CampaignContext.jsx';

const StudentDashboard = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") ? parseInt(localStorage.getItem("activeTab")) : 1;
  });
  const [referralInfo, setReferralInfo] = useState([]);
  const [inprogress, setInporgress] = useState([]);
  const [enrolled, setEnrolled] = useState([]);
  const [point, setPoint] = useState({});
  const { saveCampaignData, campaign, source, medium } = useCampaign();
  const [referralView, setReferralView] = useState(false);
  const [referral, setReferral] = useState(false);
  const [balance, setBalance] = useState({})
  const [lastTransaction, setLastTransaction] = useState(null)

  const { token, user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { id: 1, label: "Home", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { id: 2, label: "Wallet", icon: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" },
  ];

  const getQueryParams = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const campaignParam = getQueryParams("utm_campaign") || campaign || "NA";
  const sourceParam = getQueryParams("utm_source") || source || "NA";
  const mediumParam = getQueryParams("utm_medium") || medium || "NA"

  useEffect(() => {
    saveCampaignData(sourceParam, campaignParam, mediumParam);
  }, [sourceParam, campaignParam, mediumParam, saveCampaignData]);

  const studentReferral = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/referrals/my-referrals`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (resp.status === 200) {
        const referrals = resp.data.referral.reverse();
        setReferralInfo(referrals);
        const progress = referrals.filter((item) => item.status === "inprogress");
        const enrolledCandidate = referrals.filter((item) => item.status === "enrolled");
        setInporgress(progress);
        setEnrolled(enrolledCandidate);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  const studentCurrentReedemPoint = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/points/balance`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 200) {
        setPoint(resp.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  useEffect(() => {
    studentCurrentReedemPoint();
  }, [studentCurrentReedemPoint]);

  const studentPoint = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/points/currentbalance`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 200) {
        setBalance(resp.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  const fetchAllTransaction = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/points/transactions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 200) {
        setLastTransaction(resp.data.data.transactions[0] || null);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  useEffect(() => {
    studentPoint();
    studentReferral();
    fetchAllTransaction();
  }, [studentPoint, studentReferral, fetchAllTransaction]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    localStorage.setItem("activeTab", tabId);
    setReferralView(false);
    setReferral(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const signout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null)
    navigate(location.state?.from?.pathname ?? "/", { replace: true });
    saveCampaignData('', '', '')
  };

  useEffect(() => {
    const storedPopupState = localStorage.getItem('referralView');
    if (storedPopupState === 'true') setReferralView(true);
    const storedRefState = localStorage.getItem('referral');
    if (storedRefState === 'true') setReferral(true);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans selection:bg-[#004f6b]/10 selection:text-[#004f6b]">
      {/* Premium Header */}
      <header className="sticky top-0 z-[60] bg-white border-b border-gray-100 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)]">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Brand Section */}
            <div className="flex items-center gap-10">
              <div
                className="flex-shrink-0 cursor-pointer group"
                onClick={() => navigate('/student')}
              >
                <img src={logo} alt="Vignan Online" className="h-10 w-auto object-contain group-hover:drop-shadow-sm transition-all" />
              </div>

              {/* User Identity */}
              <div className="hidden lg:flex items-center gap-4 py-2 px-5 bg-gray-50 rounded-2xl border border-gray-100">
                <div className="h-10 w-10 flex items-center justify-center bg-[#004f6b] text-white rounded-xl font-semibold text-lg shadow-inner">
                  {user.first_name?.charAt(0)}
                </div>
                <div className="flex flex-col text-start">
                  <p className="text-sm font-semibold text-gray-900 leading-none">{user.first_name}</p>
                  <p className="text-xs font-medium text-[#004f6b] mt-1 opacity-80">Student Ambassador</p>
                </div>
              </div>
            </div>

            {/* Actions Section */}
            <div className="flex items-center gap-6">
              {/* <div className="hidden sm:flex items-center gap-2 group cursor-pointer">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Referral Active</span>
              </div> */}

              <button
                onClick={signout}
                className="group flex items-center gap-3 px-5 py-2.5 text-sm font-medium text-gray-600 hover:text-red-600 bg-gray-50 hover:bg-red-50 rounded-xl border border-gray-200 hover:border-red-100 transition-all active:scale-95 shadow-sm"
              >
                <span>Logout</span>
                <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Modern Navigation Tabs */}
      <nav className="sticky top-20 z-50 bg-white border-b border-gray-100/80 backdrop-blur-md shadow-sm overflow-hidden">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-1 overflow-x-auto py-2 scrollbar-none no-scrollbar">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`group relative flex-shrink-0 flex items-center gap-2.5 px-8 py-5 transition-all duration-300 ${isActive
                    ? "text-[#004f6b]"
                    : "text-gray-800 hover:text-[#004f6b]"
                    }`}
                >
                  {/* Icon */}
                  <div className={`transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-105'}`}>
                    <svg className={`w-5 h-5 ${isActive ? 'text-[#004f6b]' : 'text-gray-800 group-hover:text-[#004f6b]'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isActive ? 2.5 : 2} d={tab.icon} />
                    </svg>
                  </div>

                  {/* Label */}
                  <span className={`text-sm font-medium tracking-tight transition-all ${isActive ? 'font-semibold opacity-100 translate-x-0' : 'opacity-80'}`}>
                    {tab.label}
                  </span>

                  {/* Active Indicator Line */}
                  {isActive && (
                    <div className="absolute bottom-0 left-6 right-6 h-1 bg-[#004f6b] rounded-t-full shadow-[0_-2px_8px_rgba(0,79,107,0.3)] anim-grow-x"></div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Dashboard Body Area */}
      <main className="flex-grow py-8 bg-gray-50/50">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <Home
            studentReferral={studentReferral}
            activeTab={activeTab}
            referralInfo={referralInfo}
            inprogress={inprogress}
            enrolled={enrolled}
            point={point}
            balance={balance}
            lastTransaction={lastTransaction}
            referralView={referralView}
            setReferralView={setReferralView}
          />
          <Wallet activeTab={activeTab} point={point} studentReferral={studentReferral} referral={referral} setReferral={setReferral} balance={balance} lastTransaction={lastTransaction} />
        </div>
      </main>

      <style jsx>{`
        @keyframes anim-grow-x {
          from { transform: scaleX(0); opacity: 0; }
          to { transform: scaleX(1); opacity: 1; }
        }
        .anim-grow-x {
          animation: anim-grow-x 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .scrollbar-none::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default StudentDashboard;
